const getStatusesUniqueIds = assets =>
  assets
    .map(({ statusId }) => statusId)
    .filter((statusId, index, theArray) => theArray.indexOf(statusId) === index);

export default getStatusesUniqueIds;
